import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9fa3d6a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigator-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-left cycle-button" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "number-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cycle-text" }, "of", -1))
const _hoisted_6 = { class: "number-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-right cycle-button" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "icon-container",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('cycleLeft')), ["stop"]))
    }, _hoisted_3),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentIndex + 1), 1),
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.totalItems), 1)
    ]),
    _createElementVNode("div", {
      class: "icon-container",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('cycleRight')), ["stop"]))
    }, _hoisted_8)
  ]))
}